import MyProducts from './MyProducts';

function MyCoursesList() { 
    return (
        <>
            <MyProducts forpage="eproducts" section="eproducts" />
        </>
    );
}

export default MyCoursesList;
